import * as React from "react";
import update = require("react-addons-update");

import { Address } from "../../models/Address";
import { Customer } from "../../models/Customer";

import ShoppingBasketStore from "../../stores/ShoppingBasketStore";
import DarienSqlStore from "../../stores/DarienSqlStore";
import { DarienSqlAction } from "../../actions/DarienSqlActions";

import { VerifyIdentity } from "./VerifyIdentity";
import { ShoppingBasket } from "../shoppingbasket/ShoppingBasket";
import { ResidentVerification } from "./Models";

require("../../styles/Darien.scss");

export interface DarienShellProps
{
	mode:string
}

export class DarienShell extends React.Component<DarienShellProps,any>
{
	render()
	{
		return (
			<div>
				<header id="header">
					<img src="/images/darien/seal.png" />
					<h1>Town of Darien, CT - Dump Permits</h1>
				</header>
				{ this.renderMode() }
			</div>
		);
	}

	private renderMode()
	{
		if (this.props.mode === "commercial")
		{
			return <Disclaimer termsUrl="/terms-commercial.htm" disclaimerHeader={<span>Commercial Dump Permits are valid from <span style={{ color: "red" }}>January 1st to December 31st</span> of each year, the cost is $150.00 per year, per vehicle.   Permits are not pro-rated. </span>}><Commercial/></Disclaimer>;
		}
		return <Disclaimer termsUrl="/terms.htm" disclaimerHeader={<span>Disclaimer: <span style={{ color: "red" }}>Current dump permits expire June 30th of each year</span></span>}><Residential/></Disclaimer>;
	}
	
}

export interface DisclaimerProps
{
	termsUrl: string;
	disclaimerHeader:any;
}
export interface DisclaimerState
{
	hasAcceptedTerms:boolean;
}
export class Disclaimer extends React.Component<DisclaimerProps, DisclaimerState>
{
	state: DisclaimerState =
	{
		hasAcceptedTerms: false
	}
	private agreeToTerms()
	{
		this.setState(update(this.state, { $set: { hasAcceptedTerms: true } }));
	}

	render()
	{
		if (this.state.hasAcceptedTerms)
		{
			return this.props.children;
		}
		return <div>
			       <h2>{this.props.disclaimerHeader}</h2>
			       <iframe src={this.props.termsUrl} style={{ width: "100%", height: "21em" }} />
			       <button className="btn btn-primary center-block btn-lg" onClick={this.agreeToTerms.bind(this)} style={{ margin: "1em auto", display: "block" }}>I Agree</button>
		       </div>;
	}
}

export interface ResidentialState
{
	isIdentityVerified: boolean;
	verifiedResident: ResidentVerification;
}
export class Residential extends React.Component<any, ResidentialState>
{
	state: ResidentialState =
	{
		isIdentityVerified: false,
		verifiedResident: null
	}
	constructor(props: any, context: any)
	{
		super(props, context);

	}
	componentWillMount(): void
	{
		DarienSqlStore.addListener(this.darienSqlStoreChanged.bind(this));
	}

	componentDidUpdate(prevProps: any, prevState: ResidentialState): void
	{
		// if we have just verified the resident, populate the shopping basket...
		if (prevState.verifiedResident === null && this.state.verifiedResident !== null)
		{
			DarienSqlStore.populateShoppingBasket(this.state.verifiedResident);
		}
	}
	private darienSqlStoreChanged(): void
	{
		if (this.state.isIdentityVerified)
		{
			var resident = DarienSqlStore.fetchResident();
			this.setState(update(this.state, { $set: { verifiedResident: resident } }));
		}
	}

	render()
	{
		if (this.state.isIdentityVerified === null || this.state.isIdentityVerified === undefined)
		{
			return <div>
				<h3>Loading...</h3>
			</div>;
		}

		return (
			<div>
				<h2>Residential Permits</h2>
				{ this.renderIdentityVerifier() }
				{ this.renderShoppingBasket() }
			</div>
		);
	}

	private renderIdentityVerifier()
	{
		if (!this.state.isIdentityVerified)
		{
			return <div className="darien-verifier">
				<VerifyIdentity verificationCallback={ this.setVerificationState.bind(this) }/>
			</div>;
		} else
		{
			return null;
		}
	}

	private renderShoppingBasket()
	{
		if (this.state.isIdentityVerified)
		{
			return <div className="darienCart">
				<ShoppingBasket showShipping={ false } allowLineItemEdits={ false } billingRequiresPhoneNumber={false} hidePONumber={true} termsLink="http://www.darienct.gov/content/28025/28549/28551/default.aspx" skipRedirectToOrderConfirmation={true} onCheckoutSuccess={this.addPermits.bind(this) }/>
			</div>;
		} else
		{
			return null;
		}
	}
	setVerificationState(state: ResidentVerification)
	{
		this.setState(update(this.state,
			{
				$set: {
					isIdentityVerified: true,
					verifiedResident: state
				}
			}));
	};
	private addPermits(orderId: string)
	{
		DarienSqlStore.addPermits().done(() =>
		{
			window.location.assign("/orderconfirmation.htm");
		});
	}
}
export interface CommercialState
{
	accountNumber: string;
	gotoCheckout: boolean;
	licensePlateNumbers: Array<string>;
	hasValidPermits: boolean;
}
export class Commercial extends React.Component<any, CommercialState>
{
	state: CommercialState = {
		accountNumber: "",
		gotoCheckout: false,
		licensePlateNumbers: [],
		hasValidPermits: false,
	}

	componentWillMount(): void
	{
		DarienSqlStore.addListener(this.darienSqlStoreChanged.bind(this));
	}
	private darienSqlStoreChanged(): void
	{
		if (!this.state.hasValidPermits)
		{
			var commercial = DarienSqlStore.fetchCommercial();
			if (commercial.Permits.length > 0)
			{
				this.setState(update(this.state, { $set: { hasValidPermits: true } }));
				DarienSqlStore.addCommercialPermits().done(() =>
				{
					this.setState(update(this.state, { $set: { gotoCheckout: true } }));
				});
			}
		}
	}
	render()
	{
		return <div className="darienCart">
			<h2>Commercial Permit</h2>
			{this.renderAccountCapture() }
			{this.renderBasket() }
		</div>;
	}
	private renderAccountCapture()
	{
		if (this.state.gotoCheckout)
			return null;

		return <div>
			<div className="form-group">
				<label htmlFor="accountNumber">Account Number</label>
				<input type="text" className="form-control" id="accountNumber" value={this.state.accountNumber} onChange={(evt: React.FormEvent<any>) =>
				{
					this.setState(update(this.state, { $set: { accountNumber: evt.target.value } }));
				} }/>
			</div>
			<div className="form-group">
				<label htmlFor="licensePlateNumber">Permit Number: 1</label>
				<input type="text" className="form-control" id="licensePlateNumber" placeholder="123ABC" onChange={
					(evt: React.FormEvent<any>) =>
					{
						this.setLicensePlate(0, evt.target.value as string);
					} }/>
			</div>
			<div className="form-group">
				<label htmlFor="licensePlateNumber2">Permit Number: 2 <i>(optional) </i></label>
				<input type="text" className="form-control" id="licensePlateNumber2" placeholder="123ABC" onChange={
					(evt: React.FormEvent<any>) =>
					{
						this.setLicensePlate(1, evt.target.value as string);
					} }/>
			</div>
			<div className="form-group">
				<label htmlFor="licensePlateNumber3">Permit Number: 3 <i>(optional) </i></label>
				<input type="text" className="form-control" id="licensePlateNumber3" placeholder="123ABC" onChange={
					(evt: React.FormEvent<any>) =>
					{
						this.setLicensePlate(2, evt.target.value as string);
					} }/>
			</div>
			<div className="form-group">
				<label htmlFor="licensePlateNumber2">Permit Number: 4 <i>(optional) </i></label>
				<input type="text" className="form-control" id="licensePlateNumber2" placeholder="123ABC" onChange={
					(evt: React.FormEvent<any>) =>
					{
						this.setLicensePlate(3, evt.target.value as string);
					} }/>
			</div>
			<div className="form-group">
				<label htmlFor="licensePlateNumber3">Permit Number: 5 <i>(optional) </i></label>
				<input type="text" className="form-control" id="licensePlateNumber3" placeholder="123ABC" onChange={
					(evt: React.FormEvent<any>) =>
					{
						this.setLicensePlate(4, evt.target.value as string);
					} }/>
			</div>
			<button className="btn btn-primary" onClick={this.gotoCheckout.bind(this) }>Checkout</button>
		</div>;
	}
	private renderBasket()
	{
		if (this.state.gotoCheckout)
		{
			return <ShoppingBasket showShipping={ false } allowLineItemEdits={ false } hidePONumber={true} termsLink=
				"http://www.darienct.gov/content/28025/28549/28551/default.aspx" skipRedirectToOrderConfirmation={true} onCheckoutSuccess={this.checkoutComplete.bind(this) }/>;
		}
	}
	private checkoutComplete()
	{
		window.location.assign("/orderconfirmation.htm");
	}
	private setLicensePlate(index: number, plate: string)
	{
		var plates = this.state.licensePlateNumbers;
		plates[index] = plate;
		this.setState(update(this.state, { $set: { licensePlateNumbers: plates } }));
	}
	private gotoCheckout()
	{
		DarienSqlStore.verifyCommercialAccount(this.state.accountNumber, this.state.licensePlateNumbers);
	}
}


// WEBPACK FOOTER //
// ./src/components/darien/DarienShell.tsx